import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationsApiAdapter } from '../adapters/NotificationsApiAdapter';

/**
 * Marca como leídas todas las notificaciones no leídas del usuario actual
 * (endpoint masivo PATCH /notifications/read).
 */
export const useMarkAllAsRead = () => {
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new NotificationsApiAdapter(httpClient);

  return useMutation({
    mutationFn: () => adapter.markAllAsRead(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};
